import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Slide, SlideHeader, itemVariants } from '../Slide';
import { BrainDiagram } from '../BrainDiagram';
export function SlideBrain() {
  return <Slide data-id="element-74">
      <SlideHeader data-id="element-75">The Internal Brain</SlideHeader>

      <div className="flex-1 flex flex-col justify-center min-h-0" data-id="element-76">
        <motion.div variants={itemVariants} className="w-full max-w-3xl mx-auto mb-8 md:mb-12 text-center" data-id="element-77">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif tracking-tight mb-3" data-id="element-78">
            One memory layer for every engineering signal.
          </h2>
          <p className="text-base md:text-lg text-gray-400" data-id="element-79">
            Waydev ingests everything that happens across your engineering org —
            and turns it into intelligence every agent, tool, and team can use.
          </p>
        </motion.div>

        <motion.div variants={itemVariants} className="w-full max-w-6xl mx-auto" data-id="element-80">
          <BrainDiagram data-id="element-81" />
        </motion.div>
      </div>
    </Slide>;
}